var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEmpleados(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_20056",
    "data-name": "Grupo 20056",
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_20055",
    "data-name": "Grupo 20055",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_20035",
    "data-name": "Grupo 20035"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_1890",
    "data-name": "Rect\\xE1ngulo 1890",
    transform: "translate(0)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "user-svgrepo-com",
    transform: "translate(7.807 7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27342",
    "data-name": "Trazado 27342",
    d: "M16,7a4,4,0,1,1-4-4A4,4,0,0,1,16,7Z",
    transform: "translate(-5 -3)",
    fill: "none",
    stroke: "#777",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27343",
    "data-name": "Trazado 27343",
    d: "M12,14a7,7,0,0,0-7,7H19A7,7,0,0,0,12,14Z",
    transform: "translate(-5 -3)",
    fill: "none",
    stroke: "#777",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmpleados);
export default __webpack_public_path__ + "static/media/icon-empleados.11af2e93bcecec6f79808c5f42e24599.svg";
export { ForwardRef as ReactComponent };